import { Middleware } from "redux";

import {
  pushDataLayer,
  getPageLoadModel,
  getServerErrorModel,
  getDataUpdateModel,
  getEcommerceModel,
  getLocalValidationErrorModel,
} from "./";
import { RECEIVE_ENCRYPTED_CUSTOMER, BASE_ROUTE, CHECKOUT_ROUTE, DONE_ROUTE } from "../store";

import { RECEIVE_INITIAL, COMPLETED, PROCESSING_END, SET_SERVER_ERROR, RECEIVE_PRICE, SET_FIELD_VALIDATION_ERROR } from "../store/actions";

import { FOOTER_COVERAGE_CHANGED } from "../store/Footer";
import { INSURANCE_RECEIVE_TYPE_CHANGED } from "../store/Insurance";
import { LOCATION_CHANGE, getLocation } from "connected-react-router";
import { isFunction } from "../helperFunctions";

const actionHistory: any[] = [];
const sequencedActions: string[] = [RECEIVE_INITIAL, RECEIVE_PRICE, SET_SERVER_ERROR, RECEIVE_ENCRYPTED_CUSTOMER, COMPLETED];

export const datalayerMiddleware: Middleware = api => next => action => {
  const previousActionType = actionHistory.length > 0 ? actionHistory[actionHistory.length - 1] : undefined;
  const currentActionType = action.type;
  if (sequencedActions.includes(currentActionType)) {
    actionHistory.push(currentActionType);
  }

  // Call the next dispatch method in the middleware chain.
  const returnValue = next(action);

  // Capture new store state - state after dispatch
  const newState = api.getState();

  // make sure to wait for action to end.
  // Previous actions (e.g. RECEIVE_INITIAL) might end into error (e.g. SET_SERVER_ERROR) and we need to push error instead of successful event
  if (currentActionType === PROCESSING_END) {
    // handle events where server response is involved
    // push correct dataLayer event based on current action
    switch (previousActionType) {
      case RECEIVE_INITIAL:
        pushDataLayer(getPageLoadModel(newState, "Page Load", "price"));
        const bravi = (window as any).Bravi;
        if (bravi && bravi.gtm && isFunction(bravi.gtm)) {
          bravi.gtm();
        }
        break;
      case SET_SERVER_ERROR:
        pushDataLayer(getServerErrorModel(newState));
        break;
      case RECEIVE_PRICE:
      case RECEIVE_ENCRYPTED_CUSTOMER:
        pushDataLayer(getDataUpdateModel(newState));
        break;
      case COMPLETED:
        pushDataLayer(getEcommerceModel(newState, "Purchase"));
        break;
    }
  } else if (currentActionType === LOCATION_CHANGE && !action.payload.isFirstRendering) {
    // handle navigation
    switch (getLocation(newState).pathname) {
      case BASE_ROUTE:
        pushDataLayer(getPageLoadModel(newState, "Virtual Page Load", "price"));
        break;
      case CHECKOUT_ROUTE:
        pushDataLayer(getPageLoadModel(newState, "Virtual Page Load", "checkout"));
        pushDataLayer(getEcommerceModel(newState, "Checkout Step"));
        break;
      case DONE_ROUTE:
        pushDataLayer(getPageLoadModel(newState, "Virtual Page Load", "purchase"));
        break;
    }
  } else {
    // handle any other cases - action is performed, but without server or page load
    switch (currentActionType) {
      case FOOTER_COVERAGE_CHANGED:
      case INSURANCE_RECEIVE_TYPE_CHANGED:
        pushDataLayer(getDataUpdateModel(newState));
        break;
      case SET_FIELD_VALIDATION_ERROR:
        pushDataLayer(getLocalValidationErrorModel(newState, action.payload));
        break;
    }
  }

  return returnValue;
};
